import { I18n } from '@/services/i18n';

type Message = {
  needInspiration: string;
  smartMatchAi: string;
  learnMore: string;
  dontWantWriting: string;
};

const messages: I18n<Message> = {
  en: {
    needInspiration: 'Need inspiration?',
    dontWantWriting: 'Don’t want to keep writing the same message?',
    smartMatchAi: 'Smart Match AI is here if you ever need a hand with that first step.',
    learnMore: 'Learn more',
  },
  es: {
    needInspiration: '¿Necesitas inspiración?',
    dontWantWriting: '¿No quieres seguir escribiendo el mismo mensaje?',
    smartMatchAi:
      'La IA de Smart Match está aquí si alguna vez necesitas ayuda con ese primer paso.',
    learnMore: 'Más información',
  },
  de: {
    needInspiration: 'Brauchst du Inspiration?',
    dontWantWriting: 'Willst du nicht immer wieder dieselbe Nachricht schreiben?',
    smartMatchAi:
      'Smart Match AI ist hier, wenn du jemals Hilfe bei diesem ersten Schritt benötigst.',
    learnMore: 'Mehr erfahren',
  },
};

export { messages };
